import DirectorFormContent from './DirectorFormContent'

export default DirectorFormContent
